<template>
  <button
    :class="`best-pick best-pick__${active ? 'selected' : 'not-selected'}`"
    @click="set_sorting(value)"
    :style="{ '--color': color, '--background': background }"
  >
    <span class="best-pick__title">
      <span v-html="svg_radio(active, color)"></span>
      {{ label }}
    </span>
    <span v-if="show_flight_data" class="best-pick__info">
      <span class="best-pick__price" v-b-popover.hover.bottom="'Prezzo per persona'">
        {{ currency(price.currency) }}
        {{ number(price.mu_price_medium_per_pax).toFixed(2) }}
      </span>
      <span class="best-pick__info__divider">&middot;</span>
      <span v-if="duration" v-b-popover.hover.bottom="'Durata media per tratta'">
        <flight-pad-duration class="best-pick__duration" :duration="duration" :font_size="14" />
      </span>
    </span>
    <b-collapse :id="`best-picks-explanations`" class="best-pick__explanation">
      {{ description }}
    </b-collapse>
  </button>
</template>

<script>
import { set_sorting, is_current_sorting } from '@/utilities/sorting';
import FlightPadDuration from '@/components/blocks/flight-pad/flight-pad-duration.vue';
import { currency } from '@/utilities';
import { info } from '@/components/svg/';
import { number } from 'mathjs';
import { radio } from '@/components/svg/';

export default {
  name: 'best-pick',
  components: {
    'flight-pad-duration': FlightPadDuration,
  },
  props: {
    label: String,
    value: String,
    price: Object,
    duration: String,
    color: String,
    background: String,
    description: {
      type: String,
      default: () => '',
    },
    show_flight_data: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      info,
    };
  },
  methods: {
    number,
    currency,
    set_sorting,
    is_current_sorting,
    svg_radio: radio,
  },
  computed: {
    active() {
      return this.is_current_sorting(this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.best-pick {
  border: 0;
  width: 100%;
  min-height: 100%;
  border-radius: 10px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: var(--background);

  &:hover {
    transition: 100ms;
  }

  &__explanation {
    font-size: 12px;
    color: $text;
    font-weight: 400;
    text-align: start;
    height: 100%;
  }

  &__title {
    color: var(--color);
    display: flex;
    gap: 7px;
    font-size: 16px;
    font-weight: 600;
  }

  &__info {
    display: flex;
    gap: 5px;
    align-items: center;
    font-size: 14px;
    &__divider {
      font-family: 40px;
      line-height: 0;
    }
    @include media-breakpoint-down(md) {
      flex-direction: column;
      &__divider {
        display: none;
      }
    }
  }
}
</style>
